import { Card } from '@components/ui/card/Card'

export function FundsListPlaceholder() {
  return (
    <Card className="mt-12 flex flex-col items-center justify-start p-8 xs:mt-20 xs:p-10">
      <img src={'/images/funds-list-placeholder.webp'} alt={''} />
      <p className="mt-8 text-h4 xs:mt-10 xs:text-h3">No funds here</p>
      <p className="mt-2 text-body2 text-cw-light-grey xs:text-body1">
        Looks like we couldn't find any matches
      </p>
    </Card>
  )
}
